import { useSelector, useDispatch } from 'react-redux'
import React, { useEffect } from 'react'
import { logEvent } from 'firebase/analytics'
import { analytics } from './firebase'
import { getGuestUser } from 'shared-ui/utils/localStorage'
import { useSubscriptionStatus } from 'shared-ui/hooks'

export const useTrackEvent = () => {
  const user = useSelector((state) => state.auth.user)
  const subscriptionStatus = useSelector(
    (state) => state.userSubscriptionData.subscriptionStatus
  )

  return (eventName, params = {}) => {
    if (!analytics) return

    const localUser = JSON.parse(localStorage.getItem('user')) || {}
    const currentUser = user || localUser
    const globalParams = {
      user_id: currentUser?.user_id || 'guest',
      // platform: navigator.userAgent.includes('Mobile') ? 'ios' : 'web',
      platform: 'web',
      app_version: window.version || '1.0.0',
      session_id: sessionStorage.getItem('session_id') || 'no-session',
      is_guest: getGuestUser() || false,
      is_subscriber:
        subscriptionStatus?.data?.user_payment_method?.is_active || false,
      credits_balance: subscriptionStatus?.data?.credits || 50
    }

    const eventParams = { ...globalParams, ...params, debug_mode: true }

    logEvent(analytics, eventName, eventParams)
  }
}
